import colorMod from 'color';
import { get } from 'lodash';

export default ({ color, fontSize, margin, typography }) => ({
  filterByURIContainer: {
    overflowY: 'auto',
    height: '90%',
  },
  valueContainer: {
    padding: 20,
    borderBottom: `1px solid ${color.borderColor}`,
  },
  nameAndRemove: {
    marginBottom: 20,
    display: 'flex',
    alignItems: 'center',
  },
  expressionWithToolTip: {
    display: 'flex',
  },
  tooltipIcon: {
    marginLeft: 2,
    fill: color.primaryButtonBackground,
    stroke: color.primaryButtonText,
  },
  helpIcon: {
    fontSize: 20,
    margin: get(margin, 'm2'),
    verticalAlign: 'middle',
    cursor: 'pointer',
    color: `${get(color, 'link')} !important`,
  },
  tooltip: {
    maxWidth: 600,
    fontSize: fontSize.smallText,
  },
  inputFiledContainer: {
    marginBottom: '0px !important',
    marginTop: '0px !important',
  },
  textFieldLabel: {
    display: 'none',
  },
  inputContainer: {
    display: 'flex',
    marginTop: 20,
  },
  invalidTextInput: {
    '& input': {
      borderColor: '#DB4232',
    },
    '&:focus div': {
      boxShadow: '0 0 0 1px #ffffff, 0 0 0 2px #DB4232',
    },
    '& input:focus + div': {
      boxShadow: '0 0 0 1px #ffffff, 0 0 0 2px #DB4232',
    },
    '& div': {
      borderColor: '#DB4232',
    },
  },
  smallLabelAbove: {
    fontSize: 12,
    marginBottom: 2,
  },
  smallLabelBelow: {
    fontSize: 12,
    marginTop: 3,
  },
  smallLabelBelowError: {
    fontSize: 12,
    marginTop: 3,
    color: 'red',
  },
  button: {
    margin: '10px 10px',
  },
  filterLabel: {
    fontSize: fontSize.small,
  },
  label: {
    marginBottom: 5,
  },
  errorMessage: {
    marginTop: 3,
    marginBottom: 0,
    color: 'red',
    fontSize: fontSize.small,
  },
  addValueButton: {
    margin: 20,
    height: 40,
    color: color.primaryButtonBackground,
    background: color.primaryButtonText,
    borderRadius: 3,
    fontFamily: typography.buttonText,
    fontSize: fontSize.buttonText,
    border: '1px solid',
    borderColor: color.primaryButtonBackground,
    '&:hover': {
      background: `${colorMod(color.primaryButtonBackground).alpha(0.05).string()} !important`,
    },
    '&:focus': {
      background: `${colorMod(color.primaryButtonBackground).alpha(0.05).string()} !important`,
      outline: 'none',
    },
    '&:active': {
      background: `${colorMod(color.primaryButtonBackground).alpha(0.05).string()} !important`,
    },
  },
  addValueButtonDisabled: {
    color: colorMod(color.bodyText).alpha(0.8).string(),
    borderColor: colorMod(color.bodyText).alpha(0.05).string(),
  },
  removeValueButton: {
    margin: 20,
  },
  tooltipList: {
    listStyleType: 'none',
  },
});
